<!-- Tarjetas resumen de conductores -->
<div class="max-w-7xl mx-auto my-10 grid grid-cols-1 md:grid-cols-4 gap-3">

    <!-- Conductores activos -->
    <div class="bg-white dark:bg-[#19191c] rounded-xl shadow-md p-6 flex flex-col items-center justify-center border-l-4 border-blue-500">
        <i class="pi pi-users text-gray-400 dark:text-gray-50 text-3xl mb-2"></i>
        <p class="text-blue-500 font-bold text-sm">CONDUCTORES ACTIVOS</p>
        <div class="mt-2 flex items-center space-x-2">
            <span class="text-xl text-gray-800 dark:text-white">{{ conductoresActivos }}/{{ totalConductores }}</span>
            <span class="text-sm text-blue-400">({{ porcentajeActivos }}%)</span>
            <div class="relative w-16 h-5 bg-gray-200 rounded-full overflow-hidden">
                <div class="absolute top-0 left-0 h-full bg-blue-500 rounded-full" [style.width.%]="porcentajeActivos"></div>
            </div>
        </div>
    </div>

    <!-- Licencia vigente -->
    <div class="bg-white dark:bg-[#19191c] rounded-xl shadow-md p-6 flex flex-col items-center justify-center border-l-4 border-green-400">
        <i class="pi pi-id-card text-gray-400 dark:text-gray-50 text-3xl mb-2"></i>
        <p class="text-green-400 font-bold text-sm">LICENCIA VIGENTE</p>
        <div class="mt-2 flex items-center space-x-2">
            <span class="text-xl text-gray-800 dark:text-white">{{ licenciaVigente }}</span>
        </div>
        <small class="mt-1 text-xs text-gray-500 dark:text-gray-300 text-center">
            {{ licenciaVencida }} con licencia vencida
        </small>
    </div>

    <!-- Manejo defensivo -->
    <div class="bg-white dark:bg-[#19191c] rounded-xl shadow-md p-6 flex flex-col items-center justify-center border-l-4 border-cyan-500">
        <i class="pi pi-shield text-gray-400 dark:text-gray-50 text-3xl mb-2"></i>
        <p class="text-cyan-500 font-bold text-sm">MANEJO DEFENSIVO VIGENTE</p>
        <div class="mt-2 flex items-center space-x-2">
            <span class="text-xl text-gray-800 dark:text-white">{{ mdVigente }}</span>
        </div>
        <small class="mt-1 text-xs text-gray-500 dark:text-gray-300 text-center">
            {{ mdVencido }} con MD vencido
        </small>
    </div>

    <!-- Alertas -->
    <div class="bg-white dark:bg-[#19191c] rounded-xl shadow-md p-6 flex flex-col items-center justify-center border-l-4 border-yellow-400">
        <i class="pi pi-exclamation-triangle text-gray-400 dark:text-gray-50 text-3xl mb-2"></i>
        <p class="text-yellow-400 font-bold text-sm">CON DOCUMENTACIÓN VENCIDA</p>
        <div class="mt-2 flex items-center space-x-2">
            <span class="text-xl text-gray-800 dark:text-white">{{ licenciaVencida + mdVencido }}</span>
        </div>
        <small class="mt-1 text-xs text-gray-500 dark:text-gray-300 text-center">Entre licencia y manejo defensivo</small>
    </div>

</div>
